/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Placeholder_IndustryInputs */

const et_contact_placeholder_industry = /** @type {(inputs: Contact_Placeholder_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukksepp, katusetööd, ehitus, detailing...`)
};

const en_contact_placeholder_industry = /** @type {(inputs: Contact_Placeholder_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locksmith, roofing, construction, detailing...`)
};

/**
* | output |
* | --- |
* | "Locksmith, roofing, construction, detailing..." |
*
* @param {Contact_Placeholder_IndustryInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_placeholder_industry = /** @type {((inputs?: Contact_Placeholder_IndustryInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Placeholder_IndustryInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_placeholder_industry(inputs)
	return en_contact_placeholder_industry(inputs)
});